<template>
    <b-row v-if="(row.mandatory === '1' || row.mandatory === 1) && row.value !== ''">
        <div class="OTloading">
            <div class="ot-icon-ecm-mandatory-ok"></div>
        </div>
    </b-row>
    <b-row v-else-if="(row.mandatory === '1' || row.mandatory === 1) && row.value === ''">
        <div class="OTloading">
            <div class="ot-icon-ecm-mandatory"></div>
        </div>
    </b-row>
    <b-row v-else>
        <div class="OTloading">
           
        </div>
    </b-row>
</template>

<script>
export default {
    props: ['row'],
     created() {
        var that = this;
        //var a = that;
    }
}
</script>